


<br><br><br>
<div class="row">
    <div class="col-4 offset-md-4  text-center">
        <h2>Reset your password</h2>
    </div>
</div>
<br>
<div class="row">
    <div class="col-md-2 offset-md-5">
        <form (ngSubmit)="onSubmit()">
            <div class="form-group">
                <label >Email</label>
                <input required name="email" 
				[(ngModel)]="model.email" required 
				#email="ngModel"
					    class="form-control" />
            </div>
            <div class="form-group">
                <label >Password</label>
                <input type="password" name="password" 
				[(ngModel)]="model.password" required 
				#password="ngModel"
				  class="form-control" />
            </div>
            <div class="form-group">
                <label >Confirm Password</label>
                <input type="password" name="confirmpassword" 
				[(ngModel)]="model.confirmpassword" required 
				#confirmpassword="ngModel"
				 class="form-control" />
            </div>
            <br>
            <button type="submit" class="btn btn-primary form-control">Reset Password</button>
        </form>
    </div>
</div>
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br /><br />
<br /><br />
<br />
<br />
<br />
<br /><br />
<br /><br />
<br />
<br />
<br />
